import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=32bf48e8&scoped=true"
import script from "./FormGenerator.vue?vue&type=script&lang=js"
export * from "./FormGenerator.vue?vue&type=script&lang=js"
import style0 from "./FormGenerator.vue?vue&type=style&index=0&id=32bf48e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf48e8",
  null
  
)

export default component.exports